<div class="header-row">
  <app-breadcrumb></app-breadcrumb>
  <!-- Search Bar Section -->
  <div class="search-container">
    <div class="search-box">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        placeholder="Search"
        [(ngModel)]="searchQuery"
        (input)="filterReleaseHistory()"
        >
      </div>
    </div>
  </div>

  <div class="release-history-container" style="margin-top: 20px;">


    <div class="release-list">
      @for (note of filteredReleaseHistory; track note) {
        <div
          class="release-item"
          (click)="toggleExpand(note)"
          [class.expanded]="note.expanded"
          >
          <div class="release-header" (click)="navigateToReleaseNote(note.key)">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
            <i class="fa-solid fa-file release-icon"></i>
            <span class="release-name">{{ note.version }} Release Notes</span>
            <!-- Updated: Show full date with day, month and year -->
            <span class="release-date">{{ note.date | date:'d MMMM y' }}</span>
            <!-- Download as PDF button -->
            <button class="download-btn" matTooltip="Download" (click)="downloadReleaseNote(note.key, note.version); $event.stopPropagation()">
              <i class="fas fa-download"></i>
            </button>
          </div>
        </div>
      }
    </div>

    @if (filteredReleaseHistory.length === 0 && searchQuery) {
      <div>
        <p>No release notes found matching "{{ searchQuery }}".</p>
      </div>
    }

    @if (releaseHistory.length === 0 && !searchQuery) {
      <div>
        <p>No release history found.</p>
      </div>
    }

    @if (errorMessage) {
      <div>
        <p class="error-message">{{ errorMessage }}</p>
      </div>
    }
  </div>